import React, { Fragment } from "react";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";

const FraudAlertRemainder = (props: any) => {
    return (
        <Fragment>
            <h3 className="content-title">Fraud Alert Reminder</h3>
            <p>
                As part of your proactive protection services, you may place a fraud alert on your credit file every year. These alerts help ensure that creditors
                contact you or take reasonable steps to verify your identity before issuing credit in your name.
            </p>
            <p>
                {props.reminderDate ? (
                    <strong>
                        You currently have a Fraud Alert Reminder set for {getFormattedDate(i18nService.get("Country"), props.formatDate(props.reminderDate))}.
                    </strong>
                ) : (
                    "You currently have no Fraud Alert Reminders set. "
                )}
                <a href="javascript:void(0);" data-a11y-dialog-show="dialog-set-fraud-alert-reminder" className="default_link" onClick={props.handleClick}>
                    <strong>Set a Fraud Alert Reminder</strong>
                </a>
                .
            </p>
        </Fragment>
    );
};

export default FraudAlertRemainder;
